import { createBrowserHistory } from 'history';
export var browserHistory = createBrowserHistory();
